import { OrganizationService, OrganizationNameService } from "@/common/api.service";
import { FETCH_ORGANIZATION_DATA, FETCH_ORGANIZATION_NAME_DATA, RESET_GLOBAL_STATE, FETCH_ORGANISATION_FEATURES, CREATE_CARE_PLAN, FETCH_CARE_PLAN } from "./actions.type";
import { SET_ORGANIZATION_DATA, SET_ORGANIZATION_NAME_DATA, SET_ORGANIZATION_ERROR, GLOBAL_STATE_RESET, SET_ORGANIZATION_FEATURES, SET_CARE_PLAN } from "./mutations.type";


const initialState = () => {
  return {
    organizationdata: [],
    organizationerror: [],
    organizationnamedata: [],
    organizationFeatures: [],
    organizationCarePlan: {}
  }
};

export const state = initialState();

const actions = {

  async [FETCH_ORGANIZATION_DATA](context, slug) {
    return await OrganizationService.get(slug).then(response => {
      context.commit(SET_ORGANIZATION_DATA, response.data)
      return response.data
    }).catch(({ response }) => {
      context.commit(SET_ORGANIZATION_ERROR, response.data.errorMessage)
      return response
    })
  },

  async [FETCH_ORGANIZATION_NAME_DATA](context, slug) {
    return await OrganizationNameService.get(slug).then(response => {
      context.commit(SET_ORGANIZATION_NAME_DATA, response.data)
      return response.data
    }).catch(({ response }) => {
      context.commit(SET_ORGANIZATION_ERROR, response.data.errorMessage)
      return response
    })
  },

  async [FETCH_ORGANISATION_FEATURES](context, slug) {
    return await OrganizationService.get(slug).then(response => {
      let features = [];
      response.data.forEach((feature) => {
        features.push({
          text: (feature.text
            .toLowerCase()
            .split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')), value: feature.value
        });
      });
      context.commit(SET_ORGANIZATION_FEATURES, features)
      return response.data
    }).catch(({ response }) => {
      context.commit(SET_ORGANIZATION_ERROR, response.data.errorMessage)
      return response
    })
  },

  async [CREATE_CARE_PLAN](context, slug) {
    return await OrganizationService.create(slug.slug, slug.params).then((response) => {
      return response
    }).catch(({ response }) => {
      context.commit(SET_ORGANIZATION_ERROR, response.data.errorMessage)
      return response
    })
  },

  async [FETCH_CARE_PLAN](context, slug) {
    return await OrganizationService.get(slug).then(response => {
      context.commit(SET_CARE_PLAN, response.data)
      return response.data
    }).catch(({ response }) => {
      context.commit(SET_ORGANIZATION_ERROR, response.data.errorMessage)
      return response
    })
  },

  [RESET_GLOBAL_STATE]({ commit }) {
    commit(GLOBAL_STATE_RESET)
  },
}

const mutations = {

  [SET_ORGANIZATION_DATA](state, organizationdata) {
    state.organizationdata = organizationdata
  },
  [SET_ORGANIZATION_NAME_DATA](state, organizationnamedata) {
    state.organizationnamedata = organizationnamedata
  },
  [SET_ORGANIZATION_FEATURES](state, organizationFeatures) {
    state.organizationFeatures = organizationFeatures
  },

  [SET_CARE_PLAN](state, organizationCarePlan) {
    state.organizationCarePlan = organizationCarePlan
  },

  [SET_ORGANIZATION_ERROR](state, error) {
    state.organizationerror = error
  },
  [GLOBAL_STATE_RESET](state) {
    Object.assign(state, initialState())
  },
}

const getters = {

  organizationdata(state) {
    return state.organizationdata;
  },

  organizationnamedata(state) {
    return state.organizationnamedata;
  },

  organizationFeatures(state) {
    return state.organizationFeatures;
  },

  organizationCarePlan(state) {
    return state.organizationCarePlan;
  }

}

export default {
  state,
  getters,
  actions,
  mutations
};